import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CancelOrderConfirmationModal = ({ show, onClose, onConfirm }) => {
  const { t } = useTranslation()

  return (
    <Modal title={t('Cancelar solicitud')} size="l" onClose={onClose} show={show}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Al confirmar la cancelación, se anulará la solicitud del cliente para que pueda iniciar una nueva solicitud de cambio o devolución sobre los productos.'
          )}
        </Text>
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={onConfirm}
            defaultLabel={t('Confirmar')}
            loadingLabel={t('Confirmando')}
            fullWidth
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default CancelOrderConfirmationModal
